import styled, { css } from "styled-components";

export const StyledYearEvent = styled.div`
  /* flex: 1; */
  width: 60rem; // изменено с 80% на 100%
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background: ${(props) => props.theme.main.background};
  background-size: contain;
  background-repeat: no-repeat;
  background-attachment: local;
  min-height: 12.5rem;
  border-radius: 0.3125rem;
  margin: 1rem 0 1rem 0;
  box-shadow: 0.3125rem 0.3125rem 0.3125rem 0px rgba(0, 0, 0, 0.5);
  filter: drop-shadow(0.3125rem 0.3125rem 0.3125rem rgba(0, 0, 0, 0.3));

  overflow: hidden;

  /* overflow-y: auto;
  scrollbar-gutter: stable;

  scrollbar-width: thin;
  scrollbar-color: #ffffff transparent; */
`;

export const StyledHeader = styled.div`
  flex-shrink: 0; /* Не сжимается */
  height: 3.75rem;
  width: 100%;
  text-align: center;
  font-size: 2.3rem;
  line-height: 3.75rem;
  font-variant-numeric: lining-nums;
  text-transform: uppercase;
  border-top-left-radius: 0.3125rem;
  border-top-right-radius: 0.3125rem;
  /* background-color: ${(props) => props.theme.main.background}; */
  color: ${(props) => props.theme.main.fontsColor.name};
  padding: 1.3125rem 0 1.3125rem 0;
`;

export const StyledContent = styled.div`
  flex: 1;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin:  1.3125rem 0;
  padding: 0 0.625rem;
  box-sizing: border-box;
  font-optical-sizing: auto;
  background-color: ${(props) => props.theme.main.background};

  overflow-y: auto;
  scrollbar-gutter: stable;

  scrollbar-width: thin;
  scrollbar-color: #ffffff transparent;
`;

const hoverStyles = css`
  &:hover {
    color: #817b4d !important; //не работает цвнт что динамический что обычно
  }
`;

export const StyledContentElem = styled.div<{
  isCursorPointer: boolean;
}>`
  width: 100%;
  display: flex;
  font-family: "Open Sans", sans-serif;
  border: 0.3125rem solid ${(props) => props.theme.main.fontsColor.border};
  color: ${(props) => props.theme.main.fontsColor.label} !important;
  padding: 1.3125rem;
  box-sizing: border-box;
  margin-top: 0.625rem;
  cursor: ${(props) => (props.isCursorPointer ? "pointer" : "default")};

  ${({ isCursorPointer }) => isCursorPointer && hoverStyles}
`;

export const StyledButton = styled.div`
  margin: 1rem auto;
  width: 6.5625rem;
  height: 1.5625rem;
  font-size: 1.3rem;
  line-height: 1.5625rem;
  color: ${(props) => props.theme.main.fontsColor.border};
  padding: 0.3125rem;
  background-color: none;
  font-weight: 400;
  text-align: center;
  margin: 0.625rem;
  cursor: pointer;
  font-family: "Cormorant Garamond", sans-serif;

  &:hover {
    color: ${(props) => props.theme.main.fontsColor.text};
  }
`;
